import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var markIsDefaultFromDirty = mutatorAction('markIsDefaultFromDirty', function (isDirty) {
    var store = connectedAccountsStore();
    store.isDefaultFromDirty = isDirty;
});
//# sourceMappingURL=markIsDefaultFromDirty.js.map